import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.16 Case 16</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="self_assessment_116"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case one, one, six, or 116. This is a
                positive case. Starting at the level of the cerebellum and
                moving superiorly, we immediately enter into the temporal and
                occipital regions. In the right occipital lobe, it is clear that
                there is loss of gray-white contrast, as increased activity is
                seen in the cortical gray matter here. The activity extends to
                the cortical rim. In the right temporal lobe, again, distinct
                white matter tracts are not identifiable, and there is loss of
                gray-white contrast. Moving superiorly, this pattern continues
                in the temporal lobes bilaterally, as well as in the occipital
                lobes bilaterally. Therefore, there is loss of gray-white
                contrast in the temporal and occipital lobes. As we continue
                moving superiorly, we enter into the frontal cortices
                bilaterally. Distinct white matter tracts are not visualized on
                the left- or the right-hand side of the frontal cortices. There
                is complete loss of gray-white contrast on the right and left,
                making both frontal cortices positive. In addition, white matter
                tracts are not delineated, moving from the front of the brain to
                the back of the brain, on the left- or on the right-hand side.
                In the posterior parietal region, there is also loss of
                gray-white contrast, seen here as well as here. As we enter into
                the medial parietal region, seen here, increased activity is
                seen in the midline on the right-hand side, as well as on the
                left-hand side. To further localize this region, you can utilize
                the accompanying sagittal images to see increased activity
                within the medial parietal region. This area also includes the
                precuneus. On the accompanying coronal images, increased
                activity can be seen extending to the cortical rim and within
                the gray matter, as can be seen here on the left, as well as on
                the right. After reviewing all the slices within the scan, it is
                clear that there is loss of gray-white contrast in the parietal,
                frontal, temporal, and occipital regions. Therefore, this case
                is positive. If you called this case negative, I invite you to
                review the case once again in the MIM Viewer, concentrating on
                the regions described.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-15"
          nextLesson="/module-3/module-3-0-17"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_417810992&entry_id=1_y28l9ner&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_y28l9ner"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
